<script setup lang="ts">
import { ref, watch } from 'vue';
import { UiDialog, UiTextarea } from '@shopexperts/shared';

defineProps<{
  isLoading?: boolean;
}>();

const model = defineModel<boolean>({ default: false });

const emit = defineEmits<{
  confirm: [notes: string];
  cancel: [];
}>();

const moderationNotes = ref('');

watch(model, (isOpen) => {
  if (!isOpen) {
    moderationNotes.value = '';
    emit('cancel');
  }
});

const handleConfirm = () => {
  emit('confirm', moderationNotes.value);
};

const handleCancel = () => {
  model.value = false;
};
</script>

<template>
  <UiDialog
    v-model="model"
    title="Unpublish Review"
    text="Are you sure you want to unpublish this review? It will be removed from public view but can be published again later."
    primary-action-label="Unpublish Review"
    secondary-action-label="Cancel"
    @primary-action="handleConfirm"
    @secondary-action="handleCancel"
  >
    <UiTextarea
      v-model="moderationNotes"
      label="Reason for Unpublishing"
      placeholder="Enter reason for unpublishing..."
      :rows="4"
      :disabled="isLoading"
      required
    />
  </UiDialog>
</template>
